module.exports = __webpack_public_path__ + "img/health28_7-9-2021.bd52ead1.jpg";